import React from 'react';
import PropTypes from 'prop-types';

import ClearIcon from '@mui/icons-material/Clear';
import SearchIcon from '@mui/icons-material/Search';
import { TextField } from '@mui/material';

import { regExps } from '../../utils/formValidation/validationPatterns';

import classes from './searchStyles/dynamicSearch.module.css';

const SearchOnEnter = ({
    id = 'search',
    onChange,
    search,
    searchTerm,
    placeholder = 'Enter search term...',
    disabled = false,
    autocomplete = 'on'
}) => {
    const onInputChange = (e) => {
        onChange(e.target.value.replace(regExps.SEARCH_R, ''));
    };
    const onSearch = (e) => {
        if (e.key !== 'Enter') return;
        e.preventDefault();
        search();
    };

    return (
        <div className={classes.dynamicSearch}>
            <TextField
                data-testid={`test_${id}`}
                type="search"
                placeholder={placeholder}
                size={'small'}
                value={searchTerm}
                disabled={disabled}
                autoComplete={autocomplete}
                onChange={onInputChange}
                onKeyDown={onSearch}></TextField>
            <div className={`${classes.icons} ${disabled ? classes.disabled : ''}`}>
                {!searchTerm ? (
                    <SearchIcon />
                ) : (
                    <ClearIcon onClick={() => onChange('')} className={classes.clear} />
                )}
            </div>
        </div>
    );
};

export default SearchOnEnter;

SearchOnEnter.propTypes = {
    id: PropTypes.string,
    onChange: PropTypes.func.isRequired,
    search: PropTypes.func.isRequired,
    searchTerm: PropTypes.string,
    placeholder: PropTypes.string,
    disabled: PropTypes.bool,
    autocomplete: PropTypes.string
};
